import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Requires the user to be logged in. Redirects to `fallback` otherwise. */
export const ProtectedRoute: React.FC<{ children: React.ReactElement; fallback?: string }> = ({
  children,
  fallback = '/login',
}) => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? children : <Navigate to={fallback} replace />;
};

/** Only accessible when NOT logged in. Redirects logged-in users by subscription status. */
export const GuestRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isLoggedIn, hasSubscription, authLoading } = useAuth();
  if (authLoading) return null;
  return isLoggedIn ? <Navigate to={hasSubscription ? '/account' : '/pricing'} replace /> : children;
};

/** Requires login + active subscription; redirects to /pricing otherwise. */
export const SubscriptionRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isLoggedIn, hasSubscription, authLoading } = useAuth();
  if (authLoading) return null;
  return isLoggedIn && hasSubscription ? children : <Navigate to="/pricing" replace />;
};

/** Blocks pricing for users who already have active subscription. */
export const NoSubscriptionOnlyRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isLoggedIn, hasSubscription, authLoading } = useAuth();
  if (authLoading) return null;
  return isLoggedIn && hasSubscription ? <Navigate to="/account" replace /> : children;
};
